module.exports = __webpack_public_path__ + "img/colas-de-rienzo.4c71e386.jpg";